import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import { IInventoryRequestResponse } from 'types/api/inventoryRequestApi.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { declineInventoryRequest } from 'features/inventory/inventoryRequestsSlice'
import { toast } from 'react-toastify'

interface IDeclineInventoryRequestModalProps {
  closeModal: () => void
  value: IInventoryRequestResponse
  onSuccess: () => void
}

export const DeclineInventoryRequestModal = ({
  closeModal,
  value,
  onSuccess,
}: IDeclineInventoryRequestModalProps) => {
  const [declineReason, setDeclineReason] = useState('')
  const dispatch = useDispatch<AppDispatch>()
  useFocusFirstInput()
  useModalClose(closeModal)

  const handleSave = async () => {
    if (!declineReason.trim()) {
      toast.warn('Decline reason is required')
      return
    }
    const resp = await dispatch(declineInventoryRequest({ id: value.id, declineReason }))
    if (resp.meta.requestStatus === 'fulfilled') {
      onSuccess()
      closeModal()
    }
  }

  return (
    <Modal black>
      <Flex column between center>
        <Flex column gap='1rem' width='100%'>
          <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
            <TitleText weight='bold'>Decline Request</TitleText>
            <CursorPointer onClick={closeModal}>
              <CloseIcon />
            </CursorPointer>
          </Flex>
          <Input
            name='declineReason'
            labelText='Decline Reason'
            placeholder='Enter decline reason'
            value={declineReason}
            onChange={(e) => setDeclineReason(e.target.value)}
            type='textarea'
            height='100px'
            required
          />
        </Flex>
        <Button style={{ marginTop: '1rem' }} disabled={!declineReason.trim()} variant='primary' onClick={handleSave}>
          Decline
        </Button>
      </Flex>
    </Modal>
  )
}
